import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AgendaSection, ResearchTip, AgendaHeader } from "@components";
import { DemoEmptyState } from "@components/Demo";
import { $Routes } from "@routes";
import { useFetchAgendasQuery } from "@store/api/agenda";
import { useStartDemo } from "@hooks";

const HostView = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("active");
  const { startDemo, isDemoLoading } = useStartDemo({
    source: "agenda_home_empty_state",
  });

  // Check if user has any agendas to determine empty state
  const { isLoading: isLoadingAgendas } = useFetchAgendasQuery(
    {},
    { refetchOnMountOrArgChange: false }
  );
  const agendas = useSelector((state) => state.agendas.agendas);
  const pastAgendas = useSelector((state) => state.agendas.pastAgendas);
  const hasNoAgendas =
    !isLoadingAgendas &&
    (!agendas || agendas.length === 0) &&
    (!pastAgendas || pastAgendas.length === 0);

  const handleActiveTabChange = (newTab) => {
    setActiveTab(newTab);
  };

  const handleSmartAgendaClick = () => navigate($Routes.smartAgendasPage);

  return (
    <>
      <AgendaHeader
        title="Agenda Home"
        buttonText="New Smart Agenda"
        onSmartAgendaClick={handleSmartAgendaClick}
        showSparkles={false}
      />
      {hasNoAgendas && (
        <DemoEmptyState
          onDemoClick={startDemo}
          onSmartAgendaClick={handleSmartAgendaClick}
          isDemoLoading={isDemoLoading}
        />
      )}
      <ResearchTip activeTab={activeTab} />
      <AgendaSection onActiveTabChange={handleActiveTabChange} />
    </>
  );
};

export default HostView;
